"use client";

import type { ComponentProps } from "react";
import { NameNumerology } from "@/components/name-numerology/NameNumerology";

export default function NameNumerologyClient(props: ComponentProps<typeof NameNumerology>) {
  return <NameNumerology {...props} />;
}
